import { useRouter } from "vue-router";
import { computed } from "vue";
import { handleBreadcrumbs } from "./middleware/breadcrumbs";
import { scrollToTop } from "@/shared/helpers/scrollToTop";
import store from "@/store";
import moment from "moment";

export default async (to) => {
    const currentRouteName = to.name;
    const routeNeedsAuth = !!to.meta?.noAuth == false;

    scrollToTop()

    handleBreadcrumbs('afterEach', to)

    /* É rota que necessita de autenticação? */
    if ( routeNeedsAuth ) {
        saveHistoryAccess(to)
    }

    if ( currentRouteName == "dashboard" || currentRouteName == "forum" ) return checkAndRedirectAfterLogin()
}



/**
 * Verifica e redireciona o usuário após o login, 
 * caso haja uma rota salva no sessionStorage (key = redirectAfterLogin).
 * @async
*/
const checkAndRedirectAfterLogin = async () => {
    const router = useRouter();

    const redirectData = sessionStorage.getItem("redirectAfterLogin");
    
    if ( !redirectData ) return;

    const { path, hash, params } = JSON.parse(redirectData);

    if ( !path ) {
        sessionStorage.removeItem("redirectAfterLogin");
        return;
    }

    try {

        /* Se houver apenas a rota ( sem hash e params ), redireciona para ela */
        if ( !hash && ( !params || Object.keys(params).length == 0 ) ) {
            await router.push(`/${path}`);

            sessionStorage.removeItem("redirectAfterLogin");

            return
        } 

        /* Se houver hash e/ou params, redireciona para a rota com os parâmetros e hash */
        await router.push({
            path: `/${path}`,
            query: {
                ...(hash && { hasTab: true }),
                ...(params && { hasParams: true })
            }
        });

    } catch (error) {
        console.error(`afterEach: Houve um erro ao redirecionar para a rota ${path}`, error)
    }
}

/**
 * Salva o histórico de acesso do usuário.
 * @param {Object} to - O objeto de rota atual.
 * @async
*/
// eslint-disable-next-line
const saveHistoryAccess = (to) => {
    const currentMoment = moment().format('DD/MM/YYYY HH:mm:ss');

    const getPlatformAccessRecords = computed(() => 
        store.getters['auth/getPlatformAccessRecords']
    )

    console.log('getPlatformAccessRecords', getPlatformAccessRecords.value)

    const currentAccessCount = getPlatformAccessRecords.value.count;

    store.dispatch('auth/setPlatformAccessRecords', {
        count: currentAccessCount + 1,
        ...(currentAccessCount == 0 && { date_first_access: currentMoment }),
        date_last_access: currentMoment,
    })
}